import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs/internal/Observable';
// import { environment } from 'src/environments/environment.prod';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';
export interface SubmitPayload {
  redirectFlag: string;          // 'SUBMIT' | 'BACK'
  formData?: any;
  message?: string;
  userName?: string | null;      // ✅ added
  userId?: string | null;        // ✅ added
}
@Injectable({
  providedIn: 'root'
})
export class MasterserviceService {

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Credentials': 'true',
      'Access-Control-Allow-Headers': 'Content-Type',
      'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
      // "authorization":'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOnsiaWQiOjQyNDEsInJvbGUiOiJBZG1pblRlc3QiLCJwYXJlbnRfaWQiOiI0MjM4LDQyMzIsNDIyOSwxIiwidXNlcl90eXBlX2lkIjo1fSwiaWF0IjoxNjEwNjAxNTM5fQ.02Lv9P48SFmxsMEBr8X2vYBTdBi5vZpYh9ZfPBi7kio'

    })
  };

private submitDataSubject = new BehaviorSubject<SubmitPayload | null>(null);
  submitData$ = this.submitDataSubject.asObservable();

  // Called from CashTransferFormComponent on Submit/Back
  setsubmit(data: SubmitPayload) {
    this.submitDataSubject.next(data);
  }

  // Clear after consumption
  clearSubmit() {
    this.submitDataSubject.next(null);
  }
  constructor(private http: HttpClient) { }

  getUrl(uri: any): any {
    return this.http.get(uri)
    //  .timeout(30000, new Error('delay exceeded'));
  }

  postUrl(uri: any, data: any): any {
    return this.http.post(uri, data)
    //  .timeout(30000, new Error('delay exceeded'));
  }
  PermissionAvailableMenuLayerTwo(id: any): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/PermissionAvailableMenuLayerTwoApi.php?layerOneId=' + id).pipe(map(res => res))

  }
    UserHitApi(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/UserHitApi.php', data).pipe(map(res => res));
  }
      UserHitView(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/UserAccessViewApi.php', data).pipe(map(res => res));
  }
   getOrganizationType(): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/ViewAllOrganizationTypeApi.php').pipe(map(res => res))
  }
  getCorporation(): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/ViewAllCorporateApi.php').pipe(map(res => res))
  }
  DeptEmpAccess(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/EmployeeDepartmentAccessApi.php', data).pipe(map(res => res));
  }
  EmpRoleAccess(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/EmployeeRoleAccessApi.php', data).pipe(map(res => res));
  }
  getdesignation(): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/ViewAllAdminDesignation.php').pipe(map(res => res))
  }
  addOrganizationType(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/AddOrganizationTypeApi.php', data).pipe(map(res => res));
  }
  getOrganizationtypeByid(id: any): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/ViewOrganizationTypeApi.php?id=' + id).pipe(map(res => res))
  }

  updteOrganizationtype(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/UpdateOrganizationTypeApi.php', data).pipe(map(res => res));
  }

  deletOrganizationType(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/DeleteOrganizationTypeApi.php', data).pipe(map(res => res));
  }
  activateorganizationType(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/ActiveOrganizationTypeApi.php', data).pipe(map(res => res));
  }
  getarea(): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/GetBusinessUnitCodeApi.php').pipe(map(res => res))
  }
  getrole(id: any): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/get_all_Role.php?id=' + id).pipe(map(res => res))
  }
  // Corporation Api Start
  addCorporate(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/AddCorporateApi.php', data).pipe(map(res => res));
  }
  getCorporateByid(id: any): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/ViewCorporateApi.php?id=' + id).pipe(map(res => res))
  }
  updteCorporate(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/UpdateCorporateApi.php', data).pipe(map(res => res));
  }
  deletCorporation(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/DeleteCorporateApi.php', data).pipe(map(res => res));
  }
  activateCorporation(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/ActiveCorporateApi.php', data).pipe(map(res => res));
  }
  // Corporation Api End
 SubtypeFollowrate(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/PatientSubtypeFollowrate.php', data).pipe(map(res => res));
  }
  // Location Api Start
  getlocation(): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/ViewAllLocationApi.php').pipe(map(res => res))
  }
  deletLocation(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/DeleteLocationApi.php', data).pipe(map(res => res));
  }
  activateLocation(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/ActiveLocationApi.php', data).pipe(map(res => res));
  }
  getcountry(): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/GetCountry.php').pipe(map(res => res))
  }
  getstate(id: any): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/GetStateName.php?id=' + id).pipe(map(res => res))
  }
  addlocation(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/AddLocationApi.php', data).pipe(map(res => res));
  }
  updatelocation(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/UpdateLocationApi.php', data).pipe(map(res => res));
  }
  getLocationByid(id: any): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/ViewLocationApi.php?id=' + id).pipe(map(res => res))
  }
  // Location Api End


  // Role Master Api Start
  getrolemaster(): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/ViewallAdminRoleMaster.php').pipe(map(res => res))
  }
  getrolemasterpage(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/ViewallAdminRoleMaster.php', data).pipe(map(res => res))
  }
  deleteRolemaster(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/DeleteAdminRoleMaster.php', data).pipe(map(res => res));
  }
  activeRolemaster(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/ActiveAdminRoleMaster.php', data).pipe(map(res => res));
  }
  viewRolemasterById(id: any): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/ViewAdminRoleMaster.php?id=' + id).pipe(map(res => res))
  }
  viewAdminRoleMasterBusinessunit(id: any): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/ViewAdminRoleMasterBusinessunit.php?roleId=' + id).pipe(map(res => res))
  }
  getSysDepartment(): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/GetSysDepartment.php').pipe(map(res => res))
  }
  getDepartment(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/GetSingleDependancyApi.php', data).pipe(map(res => res));
  }
  updateAdminRoleMaster(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/UpdateAdminRoleMaster.php', data).pipe(map(res => res));
  }
  addAdminRoleMaster(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/AddAdminRoleMaster.php', data).pipe(map(res => res));
  }
  getpermissionRoleDetails(id: any): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/permission_role_details.php?roleid=' + id).pipe(map(res => res))
  }
  getModuleName(data, id): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/get_module.php?roleid=' + data + "&created_by=" + id).pipe(map(res => res))
  }

  getSubmodule(id: any): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/getSubModule.php?id=' + id).pipe(map(res => res))
  }
  getpermissionAvailableMenu(id: any): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/permission_available_menu.php?moduleid=' + id).pipe(map(res => res))
  }
  activitySubmit(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/permission_activity_submit.php', data).pipe(map(res => res));
  }
  Roleviewactivityview(data: any): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/permission_assigned_menu.php?roleid=' + data).pipe(map(res => res));
  }
  // Role Master Api End

  // Department Master Api Start
  getdepartment(): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/ViewAllMasterDept.php').pipe(map(res => res))
  }
  deletedepartment(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/DeleteMasterDepartmentsApi.php', data).pipe(map(res => res));
  }
  activedepartment(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/ActiveMasterDepartmentsApi.php', data).pipe(map(res => res));
  }
  getdepartmentByid(id: any): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/ViewDeptMaster.php?id=' + id).pipe(map(res => res))
  }
  updatedepartment(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/UpdateMasterdepartmentsApi.php', data).pipe(map(res => res));
  }
  adddepartmestaer(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/AddMasterDepartmentsApi.php', data).pipe(map(res => res));
  }
  deptroleview(data: any): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/permission_dept_role.php?deptid=' + data).pipe(map(res => res));
  }
  // Department Master Api End

  // Permission Master Api Start

  getperroledetails(id: any): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/permission_role_details.php?roleid=' + id).pipe(map(res => res))
  }
  getpermissionbyid(id: any): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/view_permission_master.php?roleid=' + id).pipe(map(res => res))
  }

  submitPermission(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/view_permission_submit.php', data).pipe(map(res => res));
  }



  // Permission Master Api End

  // Code Master Api Start

  getcodemaster(): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/ViewAllCodeMaster.php').pipe(map(res => res))
  }
  deletecode(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/DeleteCodeMaster.php', data).pipe(map(res => res));
  }
  activecode(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/ActiveCodeMaster.php', data).pipe(map(res => res));
  }
  updatecodeMaster(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/UpadateCodeMaster.php', data).pipe(map(res => res));
  }
  addcodeMaster(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/AddCodeMaster.php', data).pipe(map(res => res));
  }
  getcodembyid(id: any): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/ViewCodeMaster.php?id=' + id).pipe(map(res => res))
  }

  // Code Master Api End

  // Designation Master Api Start
  admindesignation(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/AdminDesignationApi.php', data).pipe(map(res => res));
  }

  // Designation Master Api End

  // Account Master Api Start

  getmasterschedule(): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/COA_ViewAllSubSchedule.php').pipe(map(res => res))
  }

  // Account Master Api End

  // Item Master Api Start
  addItem(data: any): Observable<any> {
    return this.postUrl(`${environment.invapiUrl}` + '/InvGetAllDependencyApi.php', data).pipe(map(res => res));
  }
  addGroup(data: any): Observable<any> {
    return this.postUrl(`${environment.invapiUrl}` + '/InvGetAllDependencyApi.php', data).pipe(map(res => res));
  }
  addClassification(data: any): Observable<any> {
    return this.postUrl(`${environment.invapiUrl}` + '/InvGetAllDependencyApi.php', data).pipe(map(res => res));
  }
  addUOM(data: any): Observable<any> {
    return this.postUrl(`${environment.invapiUrl}` + '/InvGetAllDependencyApi.php', data).pipe(map(res => res));
  }
  getItem(data: any): Observable<any> {
    return this.postUrl(`${environment.invapiUrl}` + '/InvGetAllDependencyApi.php', data).pipe(map(res => res));
  }
  getSpecification(data: any): Observable<any> {
    return this.postUrl(`${environment.invapiUrl}` + '/InvGetAllDependencyApi.php', data).pipe(map(res => res));
  }
  getCatagory(data: any): Observable<any> {
    return this.postUrl(`${environment.invapiUrl}` + '/InvGetAllDependencyApi.php', data).pipe(map(res => res));
  }
  addItemMaster(data: any): Observable<any> {
    return this.postUrl(`${environment.invapiUrl}` + '/InvMItemMasterApi.php', data).pipe(map(res => res));
  }
  Itemcode(data: any): Observable<any> {
    return this.postUrl(`${environment.invapiUrl}` + '/InvMItemMasterApi.php', data).pipe(map(res => res));
  }
  ItemViewall(data: any): Observable<any> {
    return this.postUrl(`${environment.invapiUrl}` + '/InvMItemMasterApi.php', data).pipe(map(res => res));
  }
  addBrand(data: any): Observable<any> {
    return this.postUrl(`${environment.invapiUrl}` + '/InvMItemMasterApi.php', data).pipe(map(res => res));
  }
  getBrand(data: any): Observable<any> {
    return this.postUrl(`${environment.invapiUrl}` + '/InvMItemMasterApi.php', data).pipe(map(res => res));
  }
  editItem(data: any): Observable<any> {
    return this.postUrl(`${environment.invapiUrl}` + '/InvMItemMasterApi.php', data).pipe(map(res => res));
  }

  addItemGroup(data: any): Observable<any> {
    return this.postUrl(`${environment.invapiUrl}` + '/itemGroupApi.php', data).pipe(map(res => res));
  }
  getItemGroup(data: any): Observable<any> {
    return this.postUrl(`${environment.invapiUrl}` + '/itemGroupApi.php', data).pipe(map(res => res));
  }
  getItemGroupbyId(data: any): Observable<any> {
    return this.postUrl(`${environment.invapiUrl}` + '/itemGroupApi.php', data).pipe(map(res => res));
  }
  updateItemGroupbyId(data: any): Observable<any> {
    return this.postUrl(`${environment.invapiUrl}` + '/itemGroupApi.php', data).pipe(map(res => res));
  }
  getItemDetalbyId(data: any): Observable<any> {
    return this.postUrl(`${environment.invapiUrl}` + '/InvMItemMasterApi.php', data).pipe(map(res => res));
  }
  editItemDetalbyId(data: any): Observable<any> {
    return this.postUrl(`${environment.invapiUrl}` + '/InvMItemMasterApi.php', data).pipe(map(res => res));
  }
  getSpecificationDetails(data: any): Observable<any> {
    return this.postUrl(`${environment.invapiUrl}` + '/InvMItemMasterApi.php', data).pipe(map(res => res));
  }
  getBrandbyId(data: any): Observable<any> {
    return this.postUrl(`${environment.invapiUrl}` + '/InvMItemMasterApi.php', data).pipe(map(res => res));
  }
  updateBrandbyId(data: any): Observable<any> {
    return this.postUrl(`${environment.invapiUrl}` + '/InvMItemMasterApi.php', data).pipe(map(res => res));
  }
  activeBrandbyId(data: any): Observable<any> {
    return this.postUrl(`${environment.invapiUrl}` + '/InvMItemMasterApi.php', data).pipe(map(res => res));
  }
  inActiveBrandbyId(data: any): Observable<any> {
    return this.postUrl(`${environment.invapiUrl}` + '/InvMItemMasterApi.php', data).pipe(map(res => res));
  }
  inActiveGroupId(data: any): Observable<any> {
    return this.postUrl(`${environment.invapiUrl}` + '/itemGroupApi.php', data).pipe(map(res => res));
  }
  MBrandmaster(data: any): Observable<any> {
    return this.postUrl(`${environment.invapiUrl}` + '/MBrandMasterApi.php', data).pipe(map(res => res));
  }
  removeSpecificationById(data: any): Observable<any> {
    return this.postUrl(`${environment.invapiUrl}` + '/InvMItemMasterApi.php', data).pipe(map(res => res));
  }
  removeSpecBrandById(data: any): Observable<any> {
    return this.postUrl(`${environment.invapiUrl}` + '/InvMItemMasterApi.php', data).pipe(map(res => res));
  }

  getDeptClass(): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/GetDepartmentClassificationApi.php').pipe(map(res => res))
  }
  // Item Master Api End
  //Master designation Start

  Designation(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/M_DesignationApi.php', data).pipe(map(res => res));
  }
  //Master designation End

  //Test Category Api Start
  TestCategory(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatientTestCategoryApi.php', data).pipe(map(res => res));
  }
  moduleStatus(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/GetSingleDependancyApi.php', data).pipe(map(res => res));
  }
  AddStatus(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatientWorkflowStatusApi.php', data).pipe(map(res => res));
  }
  //Test Category Api End

  //Test Type Api Start
  TestType(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/SysPatientTestTypeApi.php', data).pipe(map(res => res));
  }
  //Test Type Api End

  //Service Master Api Start
  serviceClassification(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/GetSingleDependancyApi.php', data).pipe(map(res => res));
  }
  serviceCatagory(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/AdminServiceCategoryApi.php', data).pipe(map(res => res));
  }
  serviceSubCategory(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/AdminServiceSubcategoryApi.php', data).pipe(map(res => res));
  }
  ServiceMaster(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/AdminServiceMasterApi.php', data).pipe(map(res => res));
  }
  serviceItem(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/AdminServiceItemApi.php', data).pipe(map(res => res));
  }

  classificationSer(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/AdminServiceClassificationApi.php', data).pipe(map(res => res));
  }
  //Service Master Api end

  //Tax Master Api Start
  taxMaster(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/AdminServiceTaxslab.php', data).pipe(map(res => res));
  }
  withholdingTaxMaster(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/AdminServiceTaxslab.php', data).pipe(map(res => res));
  }
  //Tax Master Api End
  //KMP Master Api Start
  KeyManagerialPerson(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/KeyManagerialPersonApi.php', data).pipe(map(res => res));
  }


  // Committee Master Api Start
  // CommitteeMaster(data: any){
  //   return this.postUrl(`${environment.apiUrl}` + '/CommitteeMasterApi.php', data).pipe(map(res => res));
  // }
  CommitteeMaster(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/CommitteeMasterApi.php', data).pipe(map(res => res));
  }
  hrmsKeYMaster(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/HrmsKeyManagerialApi.php', data).pipe(map(res => res));
  }
  AddCommite(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/MKmpCommitteApi.php', data).pipe(map(res => res));
  }
  //committee end
  //approver master start
  ApproverMaster(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/ApproverMasterApi.php', data).pipe(map(res => res));
  }
  getEmp(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/GetSingleDependancyApi.php', data).pipe(map(res => res));
  }

  addNominated(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/NominatedApproverPersonApi.php', data).pipe(map(res => res));
  }

  //bed master start

  //old bed master api Start
  roommaster(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PcManageWardCabinSetupApi.php', data).pipe(map(res => res));
  }
  bedmaster(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatientManageBedApi.php', data).pipe(map(res => res));
  }
  wardmaster(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/sys_pc_ward_name_api.php', data).pipe(map(res => res));
  }
  patientdependancy(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatienteGetAllDependencyApi.php', data).pipe(map(res => res));
  }
  //old bed master api End

  accommodationdependancy(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/ConfigurationGetalldependencyApi.php', data).pipe(map(res => res));
  }
  departmentsWiseAccomandation(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/MdepartmentsWiseAccomandationApi.php', data).pipe(map(res => res));
  }

  subDepartment(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/SubDepartmentApi.php', data).pipe(map(res => res));
  }
  sharedAcco(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/MsharedAccomandationSubTypeApi.php', data).pipe(map(res => res));
  }
  BedandUnitConfiguration(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/BedandUnitConfigurationApi.php', data).pipe(map(res => res));
  }
  UnitNameConfiguration(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/UnitnameConfigurationApi.php', data).pipe(map(res => res));
  }
  BedNameConfiguration(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/BedMasterConfigurationApi.php', data).pipe(map(res => res));
  }
  IcuSubDept(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/MicuSubDepartmentsApi.php', data).pipe(map(res => res));
  }
  //bed master end

  getBoardandOutider(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/GetSingleDependancyApi.php', data).pipe(map(res => res));
  }

  // master.service.ts
  AccomadationMaster(data: any): Observable<any> {
    return this.http.post<any>(
      `${environment.patapiUrl}/Pc_AccomandationApi.php`,
      data,
      { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) }
    );
  }

  bedAllotment(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatientEmpnBedAllotmentApi.php', data).pipe(map(res => res));
  }
  getDept(id: any): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/get_Dept_Area.php?id=' + id).pipe(map(res => res))
  }
  SwipeMachine(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/AdminPcSwipemachineApi.php', data).pipe(map(res => res));
  }
  GetSingleDependancy(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/GetSingleDependancyApi.php', data).pipe(map(res => res));
  }
  BillingCounter(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/AdminPcBillingCounterApi.php', data).pipe(map(res => res));
  }
  BillingCounterSetting(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/AdminPcBillingCounterSettingApi.php', data).pipe(map(res => res));
  }
  CounterType(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/AdminPcCounterTypeApi.php', data).pipe(map(res => res));
  }
  CounterLocation(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/AdminPcCounterLocationApi.php', data).pipe(map(res => res));
  }
  AddCounter(data: any): Observable<any> {
    return this.postUrl(`${environment.accountingUrl}` + '/CounterTypeMatrixApi.php', data).pipe(map(res => res));
  }
  getBillManager(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/GetBillManagerAPI.php', data).pipe(map(res => res))
  }
  AddCashCounter(data: any): Observable<any> {
    return this.postUrl(`${environment.accountingUrl}` + '/CashCounterMatrixApi.php', data).pipe(map(res => res));
  }
  getCOACode(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/CoaMasterApi.php', data).pipe(map(res => res));
  }
  getIcons(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/RolewiseIconApi.php', data)
  }
  getSubmodules(moduleId: any): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/get_submodule_icon.php?moduleId=' + moduleId).pipe(map(res => res))
  }

  convertCSVToJSONRequisitionData(array, filedMapping): any {
    const transformArray = [];
    for (const element of array) {
      if (element === undefined) {
        continue;
      }
      const currentNewElement = {};
      filedMapping.forEach((currentPair: {}, value) => {
        for (const filed of Object.keys(currentPair)) {
          const header = currentPair[filed];
          currentNewElement[filed] = element[header];
        }
      });
      transformArray.push(currentNewElement);
    }
    return transformArray
  }

  itemType(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/ItemTypeApi.php', data)
  }

  itemCategory(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/ItemCategoryApi.php', data)
  }

  itemClassification(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/ItemClassificationApi.php', data)
  }
  singleDataBasedOnId(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/GetSingleDependancyApi.php', data)
  }
  itemSubCategory(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/ItemSubCategoryApi.php', data)
  }

  itemUOM(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/ItemUomApi.php', data)
  }

  brandList(data: any): Observable<any> {
    return this.postUrl(`${environment.invapiUrl}` + '/MBrandMasterApi.php', data)
  }

  getCurrency(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/AllCurrencyApi.php', data)
  }
  location(): Observable<any> {
    return this.getUrl(`${environment.apiUrl}` + '/GetLocation.php')
  }

  saveItemUpload(data: any): Observable<any> {
    return this.postUrl(`${environment.invapiUrl}` + '/InvMItemMasterBulkUpdateApi.php', data).pipe(map(res => res));
  }
  getallitem(data: any): Observable<any> {
    return this.postUrl(`${environment.invapiUrl}` + '/InvDepartmentRequistionApi.php', data).pipe(map(res => res));
  }
  saveVendorUpload(data: any): Observable<any> {
    return this.postUrl(`${environment.Prpo}` + '/vendorEmpanelmentApi.php', data).pipe(map(res => res));
  }
  InvMItemMasterBulkUpdate(data: any): Observable<any> {
    return this.postUrl(`${environment.invapiUrl}` + '/InvMItemMasterBulkUpdateApi.php', data).pipe(map(res => res));
  }
  getItemsByName(itemName: string) {
    const params = { itemName };
    return this.http.get<any[]>(
      `${environment.invapiUrl}/GetIItemMasterdataApi.php`,
      { params }
    );
  }
  patientType(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatienteGetAllDependencyApi.php', data).pipe(map(res => res));
  }
  patientSubType(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatienteGetAllDependencyApi.php', data).pipe(map(res => res));
  }
  CreditApprovalSetting(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/CreditApprovalSettingApi.php', data).pipe(map(res => res));
  }
  getUserWIseDailyReport(data: any): Observable<any> {
    return this.postUrl(`${environment.accountingUrl}` + '/UserWiseDailyReconcillationApi.php', data).pipe(map(res => res));
  }
  privilegeMembershipCard(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/PrivilegeMembershipCard.php', data).pipe(map(res => res));
  }
    PrivilegeMembershipCardadd(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/PrivilegeMembershipCardadd.php', data).pipe(map(res => res));
  }
  HmchRealdummyReconciliation(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/HmchRealdummyReconciliation.php', data).pipe(map(res => res));
  }
  DopdDupCreationProcApi(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/DopdDupCreationProcApi.php', data).pipe(map(res => res));
  }

  // DiscountType Master Api Start
  saveDiscountType(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/DiscountType.php', data).pipe(map(res => res));
  }
  approveCashWithdrawal(data: any): Observable<any> {
    return this.postUrl(`${environment.PateintbillingUrl}` + '/CashBillingWithdrawalApi.php', data).pipe(map(res => res));
  }

  //mrd
  OpdDistributionDept(data: any): Observable<any> {
    return this.postUrl(`${environment.apiUrl}` + '/OpdDistributionDepartmentWise.php', data).pipe(map(res => res));
  }
    getStatus(data: any): Observable<any> {
    return this.postUrl(`${environment.patapiUrl}` + '/PatienteGetAllDependencyApi.php', data).pipe(map(res => res));
  }
}



